import { AppMessageKeys } from '../../shared/translations/messages.ts'

export const MAIN_GREETING_IDS = [
  'main.greeting.1',
  'main.greeting.2',
  'main.greeting.3',
  'main.greeting.4',
] as const satisfies readonly AppMessageKeys[]

/** Одно и то же обращение у всех: день от эпохи UTC, по кругу из четырёх вариантов. */
export function mainGreetingId(
  now = Date.now(),
): (typeof MAIN_GREETING_IDS)[number] {
  const day = Math.floor(now / 86_400_000)
  const index =
    ((day % MAIN_GREETING_IDS.length) + MAIN_GREETING_IDS.length) %
    MAIN_GREETING_IDS.length
  return MAIN_GREETING_IDS[index]
}
